export default "__VITE_ASSET__ee09682f__"